<div class="forgot-password-wrapper">
  <div class="form-card">
    <h2>Welcome back to Montage</h2>
      <h4>Hit Continue to reset password!</h4>
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
          <!-- Email Field -->
          <mat-form-field class="full-width" appearance="fill">
              <!-- <mat-label>Email</mat-label> -->
              <mat-icon matPrefix>email</mat-icon>
              <input matInput type="email" formControlName="email" />
              <!-- <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('required')">Email is required</mat-error>
              <mat-error *ngIf="forgotPasswordForm.get('email')?.hasError('email')">Enter a valid email</mat-error> -->
          </mat-form-field>

          <!-- Old Password Field -->
          <mat-form-field class="full-width" appearance="fill">
              <!-- <mat-label>Old Password</mat-label> -->
              <mat-icon matPrefix>lock</mat-icon>
              <input matInput type="password" formControlName="oldPassword" />
              <!-- <mat-error *ngIf="forgotPasswordForm.get('oldPassword')?.hasError('required')">
                  Old password is required
              </mat-error> -->
          </mat-form-field>

          <!-- New Password Field -->
          <mat-form-field class="full-width" appearance="fill">
              <!-- <mat-label>New Password</mat-label> -->
              <mat-icon matPrefix>beenhere</mat-icon>
              <input matInput type="password" formControlName="newPassword" />
              <!-- <mat-error *ngIf="forgotPasswordForm.get('newPassword')?.hasError('required')">
                  New password is required
              </mat-error>
              <mat-error *ngIf="forgotPasswordForm.get('newPassword')?.hasError('minlength')">
                  New password must be at least 6 characters
              </mat-error> -->
          </mat-form-field>
          <div class="forgot-password">
            <a [routerLink]="['/login']" routerLinkActive="router-link-active">Back to Login!</a>
        </div>
          <button class="continue-frm-button" type="submit" [disabled]="forgotPasswordForm.invalid">
              Continue
          </button>
      </form>
  </div>
</div>
